import { PieceDocPageStorageResponse, PieceDocStorageResponse, PieceStorageResponse } from '@apiContract';
import axios from 'axios';

type PostPieceRecipientData = {
  name: string;
  address: string;
  recipientId: string;
};

type PostPieceRecipientResponse = {
  userMessage: string;
  objectData: PostPieceRecipientData;
};

export const getUploadUrl = async (pieceId: number) => {
  const response = await axios.get<PieceStorageResponse>(`Storage/GetUploadUrl/${pieceId}`);
  return response.data.objectData;
};

export const getUploadPiecePageUrl = async (pieceId: number) => {
  const response = await axios.get<PieceDocPageStorageResponse>(`Storage/GetUploadPiecePageUrl/${pieceId}`);
  return response.data.objectData;
};

export const getUploadPieceDocUrl = async (pieceId: number) => {
  const response = await axios.get<PieceDocStorageResponse>(`Storage/GetUploadPieceDocUrl/${pieceId}`);
  return response.data.objectData;
};

export const postPieceRecipient = async (data: PostPieceRecipientData) => {
  const response = await axios.post<PostPieceRecipientResponse>('ObjectsDetection/recipient', data);
  return response;
};
